import {buttonColors} from "../../../Pickers/InputTheme";
import {i18n} from "../../../../Utils/i18n/i18n";
import {Button} from "../../../Form/Button/Button";
import React, {useEffect} from "react";
import {Modal} from "../../../Smart/Modal/Modal";
import {
    SA_getCompaniesFiltered,
    SA_getCompaniesForPartner,
    SA_setCompaniesForPartner
} from "../../../../Services/SA_api";
import './SuperAdminPartnerEditCompanies.scss'
import {MultiSelectAutocomplete} from "../../../Form/AutoComplete/AutoComplete";

export const SuperAdminPartnerEditCompanies = ({partnerId}) => {
    const [editCompaniesModalOpen, setEditCompaniesModalOpen] = React.useState(false)
    const [selectedCompanies, setSelectedCompanies] = React.useState([])
    const [initialized, setInitialized] = React.useState(false)
    const onOpenModal = () => {
        setEditCompaniesModalOpen(true)
    }
    const closeEditModal = () => {
        setSelectedCompanies([])
        setInitialized(false)
        setEditCompaniesModalOpen(false)
    }

    const getFilteredCompanies = async ({query}) => {
        const filterModel = {
            filterValues: {
                search: query
            }
        }
        const companies = await SA_getCompaniesFiltered({filterModel})
        return companies.map(company => ({value: company.id, text: `${company.companyName}-${company.identifier}`}))
    }

    const onSelectCompaniesChange = async (selectedCompanies) => {
        setSelectedCompanies(selectedCompanies)
    }
    const setCompaniesForPartner = async () => {
        await SA_setCompaniesForPartner({partnerId, companyIds: selectedCompanies.map(c => c.value)})
        closeEditModal()
    }
    const init = async () => {
        const companyIds = await SA_getCompaniesForPartner({partnerId})
        const filterModel = {
            filterValues: {
                search: ""
            }
        }
        const allCompanies = await SA_getCompaniesFiltered({filterModel})
        //filter out companies that are not in companyIds
        const companies = allCompanies.filter(company => companyIds.includes(company.id))
        setSelectedCompanies(companies.map(company => ({
            value: company.id, text: `${company.companyName}-${company.identifier}`
        })))
        setInitialized(true)
    }
    useEffect(() => {
        if(editCompaniesModalOpen){
            init()
        }
    }, [editCompaniesModalOpen])

    return <div className="SuperAdminGenerateAPIKey">
        <Button color={buttonColors.GOLD}
                size="small"
                text={i18n.translate('superAdmin.editPartnerCompaniesModal.modalTitle')}
                onClick={onOpenModal}/>

        {editCompaniesModalOpen ? <Modal
            open={editCompaniesModalOpen}
            onClose={closeEditModal}>
            <div className="SuperAdminPartnerEditCompaniesModal modalWrapper">
                <div className="modalTitle">
                    <div>{i18n.translate('superAdmin.editPartnerCompaniesModal.modalTitle')}</div>
                </div>
                <div className="modalContent">
                    {initialized ? <MultiSelectAutocomplete
                        label={i18n.translate('superAdmin.editPartnerCompaniesModal.selectCompanies')}
                        fetchOptions={getFilteredCompanies}
                        initialSelectedValues={selectedCompanies}
                        onSelectionChange={onSelectCompaniesChange}/> : ''}
                </div>
                <div className="modalFooter">
                    <Button
                        color={buttonColors.GREY}
                        onClick={closeEditModal}
                        text={i18n.translate('general.close')}
                    />
                    <Button
                        color={buttonColors.YELLOW}
                        onClick={setCompaniesForPartner}
                        text={i18n.translate('superAdmin.editPartnerCompaniesModal.save')}
                    />
                </div>
            </div>
        </Modal> : ''}
    </div>
}